import { render, staticRenderFns } from "./ClosedSellcard.vue?vue&type=template&id=4beeb349&scoped=true&"
import script from "./ClosedSellcard.vue?vue&type=script&lang=js&"
export * from "./ClosedSellcard.vue?vue&type=script&lang=js&"
import style0 from "./ClosedSellcard.vue?vue&type=style&index=0&id=4beeb349&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beeb349",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/shashwat/CampusBox/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
installComponents(component, {VCard,VCarousel,VCarouselItem,VDivider})
